<template>
  <div class="checkout-buttons align-start">
    <template v-if="canMerchant">
      <v-btn
        :class="['mr-2 mb-3']"
        color="grey lighten-2 grey--text text--darken-1"
        depressed
        x-large
        block
        @mouseenter="showMerchantOrderButton"
        @click="showMerchantOrderButton"
        v-tooltip="getTooltipHtml"
        >Submit Pre-Order</v-btn
      >
      <transition name="fade">
        <v-btn
          v-if="isMerchantOrderButtonVisible"
          :to="{ name: MerchantOrdersRoute }"
          depressed
          block
          small
          color="deep-orange white--text"
          @mouseenter="clearMerchantOrderButtonTimeout"
          @mouseleave="showMerchantOrderButton"
          >Merchants: Create Order</v-btn
        >
      </transition>
    </template>
    <v-btn
      v-else
      :class="['mr-2 mb-3']"
      :color="
        isSubmitDisabled
          ? 'grey lighten-2 grey--text text--darken-1'
          : 'blue darken-2 white--text'
      "
      @click="submitClick"
      depressed
      x-large
      block
      >Submit Pre-Order</v-btn
    >
    <v-dialog
      v-if="hasRealItemsInCart"
      v-model="isAddressDialogVisible"
      width="500"
    >
      <DeliveryDetails
        v-if="isDelivery"
        :disabled="!cartHasTotal"
        :loading="getPlacingOrder"
        @close="isAddressDialogVisible = false"
        @orderConfirmed="deliveryOrderConfirmed"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { MerchantRoutes } from '@/constants/RouteNames'
import DeliveryDetails from '@/components/DeliveryDetails'
export default {
  name: 'CheckoutButtons',
  components: { DeliveryDetails },
  computed: {
    ...mapGetters('shop', ['getRequirePrepay']),
    ...mapGetters('auth', ['canMerchant']),
    ...mapGetters('cart', [
      'hasRealItemsInCart',
      'isDelivery',
      'cartHasTotal',
      'getPlacingOrder',
      'getFulfillmentSlot',
    ]),
    ...mapFields('cart', ['hasAcknowledgedPayment', 'isMenuFormValid']),
    ...mapGetters('app', ['appVersionMismatch']),
    allowOrderPlacement() {
      return (
        this.cartHasTotal &&
        this.hasRealItemsInCart &&
        this.getFulfillmentSlot &&
        (this.hasAcknowledgedPayment || !this.getRequirePrepay)
      )
    }, // allowOrderPlacement
    isSubmitDisabled() {
      return (
        !this.allowOrderPlacement ||
        !this.isMenuFormValid ||
        this.appVersionMismatch ||
        this.getPlacingOrder ||
        this.isAddressDialogVisible
      )
    }, // isSubmitDisabled
    getTooltipHtml() {
      if (!this.canMerchant) {
        return null
      }
      const text = `Merchants can only create Orders in the Owner Dashboard. Please follow the link below to create a new order.`
      return {
        content: `<div class='proxima--font'>${text}</div>`,
        html: true,
      }
    },
  },
  methods: {
    ...mapActions('cart', ['createOrder', 'setEmphasizeCartErrors']),
    submitClick() {
      if (this.appVersionMismatch) {
        return false
      }
      if (this.isSubmitDisabled) {
        this.setEmphasizeCartErrors(true)
        this.$scrollTo('#cart')
        return false
      }
      this.setEmphasizeCartErrors(false)
      this.isDelivery
        ? (this.isAddressDialogVisible = true)
        : this.createOrder()
    }, // submitClick
    deliveryOrderConfirmed() {
      this.isAddressDialogVisible = false
      this.createOrder()
    }, // deliveryOrderConfirmed
    showMerchantOrderButton() {
      this.clearMerchantOrderButtonTimeout()
      this.isMerchantOrderButtonVisible = true
      this.merchantOrderButtonTimeout = setTimeout(
        () => (this.isMerchantOrderButtonVisible = false),
        4000
      )
    }, // showMerchantOrderButton
    clearMerchantOrderButtonTimeout() {
      if (this.merchantOrderButtonTimeout) {
        clearTimeout(this.merchantOrderButtonTimeout)
      }
    }, // clearMerchantOrderButtonTimeout
  },
  data() {
    return {
      isAddressDialogVisible: false,
      merchantOrderButtonTimeout: null,
      isMerchantOrderButtonVisible: false,
      MerchantOrdersRoute: MerchantRoutes.Manage.ORDERS,
    }
  },
}
</script>
